import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
import { Table, Jumbotron, Button } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
import Menu from './menu';
import  config from '../config';
import funciones from '../middleware/funciones';
//import { Header } from 'react-bootstrap/lib/Modal';

class Resoluciones extends Component {
    constructor(props) {
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        super(props);
        this.state = {
            data: [],
            empresa : currentCompany,
            tipo : currentUserType
        };
    }
    componentDidMount() {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa' : this.state.empresa,
                'tipo' : this.state.tipo,
            }
        }
        fetch(config.servBackEnd+'/resoluciones/', datasend).then(response => response.json())
            .then(data => this.setState({ data }));
    }

    render() {
        const dato = (this.state.data) ? this.state.data : [];

        const style = {
            color: "white",
            backgroundColor: "DodgerBlue",
            padding: "10px",
            fontFamily: "Arial"
        };

        return (

            <div className="contenedor">
                <Menu></Menu>
                <Jumbotron style={style}>
                    <h1>Modulo Resoluciones</h1>
                </Jumbotron>
                <Button className="plus" size="sm" href="/resoluciones/crear/" variant="outline-primary">Crear Resolucion</Button>
                <Table hover bordered responsive size="sm" className="table">
                    <thead>
                        <tr>
                            <th>Empresa</th>
                            <th>Resolucion</th>
                            <th>Fecha Resolucion</th>
                            <th>Prefijo</th>
                            <th>Tipo Documento</th>
                            <th>Consecutivo Inicio</th>
                            <th>Consecutivo Fin</th>
                            <th>Fecha Inicial</th>
                            <th>Fecha Final</th>
                            <th>Punto de Venta</th>
                            <th>Ultima Modificacion</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dato.map(function (currentData, index) {
                            return <tr key={index + "d0"}>
                                <td key={index + "d2"}>{currentData.ID_EMPRESA}</td>
                                <td key={index + "d4"}>{currentData.RESOLUCION}</td>
                                <td key={index + "d5"}>{funciones.formatDate(currentData.FECHA_RESOLUCION)}</td>
                                <td key={index + "d6"}>{currentData.PREFIJO}</td>
                                <td key={index + "d7"}>{currentData.TIPO_DOCUMENTO}</td>
                                <td key={index + "d8"}>{currentData.CONSECUTIVO_INICIO}</td>
                                <td key={index + "d9"}>{currentData.CONSECUTIVO_FIN}</td>
                                <td key={index + "d10"}>{funciones.formatDate(currentData.FECHA_INICIAL)}</td>
                                <td key={index + "d11"}>{funciones.formatDate(currentData.FECHA_FINAL)}</td>
                                <td key={index + "d12"}>{currentData.PUNTO_VENTA}</td>
                                <td key={index + "d14"}>{funciones.formatDate(currentData.UPDATE_AT)}</td>
                                <td key={index + "d15"}><Button size="sm" href={"/resoluciones/crear/?"+currentData.ID_RESOLUCION} variant="outline-primary">Editar</Button></td>
                            </tr>;
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }
}
export default (Resoluciones);